import { updateItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            不再错过任何更新，最新漫画连载与站点动态实时追踪
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-4 pb-5 mb-5 border-b border-background-200 last:border-0 last:mb-0 last:pb-0"
            >
              <span className={`flex-shrink-0 inline-block px-2.5 py-1 rounded-md ${item.tagColor} text-background-50 text-[10px] font-medium mt-0.5`}>
                {item.tag}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed">
                  {item.title}
                </p>
                <span className="text-xs text-foreground-400 mt-1.5 block">{item.time}</span>
              </div>
              <span className="flex-shrink-0 text-xs text-foreground-400 mt-1">{item.date}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}